<template>
  <div class="login-page">
    <div class='container'>
      <div class='login-content'>
        <table class='login-table'>
          <colgroup>
              <col width="50px">
              <col width="200px">
              <col width="74px">
          </colgroup>
          <tbody>
            <tr id='logo-image'>
              <td colspan="3"></td>
            </tr>
            <tr id='place'>
              <td colspan="3">CAREER HIGH</td>
            </tr>
            <tr>
              <td>아이디:</td>
              <td><dx-text-box v-model='userId'
                  :show-clear-button="true"
                  maxLength="32"/></td>
              <td rowspan="2">
                <dx-button class='login-button'
                  :width="70"
                  :height="64"
                  type='default'
                  text="로그인"
                  styling-mode="contained"
                  :focusStateEnabled = 'false'
                  @click="onLogin($event)"
                />
              </td>
            </tr>
            <tr>
              <td>비번 :</td>
              <td><!--<input type='text' v-model='userPa'/>-->
                <dx-text-box v-model='userPa'
                  :show-clear-button="true"
                  mode="password" maxLength="12"
                  @enter-key="onEnterKey"/>
              </td>
              <td></td>
            </tr>
            <tr>
              <td id='id-save' colspan="3">
                <dx-check-box
                  v-model="isIdSave"
                  text="사번 기억하기"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id='copy-right' @click='onClose()'>
        <span>Copyright 2023 Career High All rights reserved</span>
      </div>
      <loading :active.sync="isLoading"></loading>
    </div>

  </div>
</template>
<script>

import HttpService from '../share/service/HttpService'
import ConstDef from '../share/ConstDef'
import Loading from 'vue-loading-overlay'
import LoginByUserIdAndPasswdProc from '../share/service/LoginByUserIdAndPasswdProc'

// import { DxSelectBox, DxCheckBox, DxTextBox, DxDateBox, DxButton } from 'devextreme-vue'
import { DxTextBox, DxButton } from 'devextreme-vue'
import { DxCheckBox } from 'devextreme-vue/check-box'

export default {
  name: 'login',
  data: function () {
    return {
      userId: 'SYSTEM',
      userPa: '1234568a',
      isIdSave: false,
      isLoading: false
    }
  },
  components: {
    Loading,
    DxTextBox,
    DxButton,
    DxCheckBox
  },
  created () {
    caches.keys().then(function (keyList) {
      return Promise.all(keyList.map(function (key) {
        return caches.delete(key)
      }))
    })
    document.title = ConstDef.TAB_TITLE
    if (ConstDef.apiUrl.indexOf(':8082') < 0) {
      this.userId = ''
      this.userPa = ''
    }
    let localSaveId = this.getSaveId()
    if (localSaveId !== null && localSaveId !== undefined) {
      this.isIdSave = true
      this.userId = localSaveId
    }
    if (this.$route.path.indexOf('logout') >= 0) {
      this.$store.commit('deleteUserInfo')
      this.$store.commit('deleteBaseData')
      HttpService.logout()
        .then((data) => {
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  },
  mounted () {
    this.$Q('.login-page').css('height', window.innerHeight + 'px')
    window.addEventListener('resize', this.handleResize)
  },
  updated () {
  },
  beforeDestroy: function () {
    // console.log('beforeDestroy')
    window.removeEventListener('resize', this.handleResize)
    // this.onClose()
  },
  methods: {
    getSaveId (state) {
      let result = localStorage.getItem('isSaveId')
      if ((result !== null && result !== undefined) || result === 'Y') {
        return localStorage.getItem('saveId')
      } else {
        return null
      }
    },
    handleResize (event) {
      this.$Q('.login-page').css('height', window.innerHeight + 'px')
    },
    onLogin () {
      if (this.userId === null || this.userId === '') {
        this.$snotify.error('아이디을 입력하세요.')
        return
      }
      if (this.userPa === null || this.userPa === '') {
        this.$snotify.error('비밀번호를 입력하세요.')
        return
      }
      this.setIsSaveId()
      this.login(this.userId, this.userPa)
    },
    async login (userId, userPa) {
      this.isLoading = true

      await LoginByUserIdAndPasswdProc.SendParamModel({ userId: userId, passwd: userPa }, null)
        .then((data) => {
          this.isLoading = false
          if (data.result === ConstDef.SUCCESS) {
            let userInfo = LoginByUserIdAndPasswdProc.MakeModel(data)
            if (userInfo.authResult === ConstDef.SUCCESS) {
              if (userInfo.userStatus === 'T') {
                this.$snotify.error('해지된 사용자 입니다.')
              } else if (userInfo.userStatus === 'P') {
                this.$snotify.error('일시중지된 사용자 입니다.')
              } else if (userInfo.permission === ConstDef.생산현장직_권한) {
                this.$snotify.error('접근권한이 없습니다.')
              } else {
                this.$store.commit('saveUserInfo', userInfo)
                if (userInfo.userId === this.userPa) {
                  console.log(userInfo)
                  this.$router.replace('/myPage?beforeUrl=/&initpa=1')
                } else {
                  this.$router.replace('/main')
                }
              }
            } else {
              this.$snotify.error('로그인 정보가 정확하지 않습니다.')
            }
          } else {
            // console.log(data.result)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    savePageAccessHis (userInfo, url) {
      let param = [
        {
          accessDate: this.$_appLib.getNow(),
          menuName: '로그인',
          userId: userInfo.userId,
          userName: userInfo.userName,
          menuUrl: url
        }
      ]
      this.$_sp.runInsertSqlProc('PAGE_ACCESS_HIS', null, param)
        .then((data) => {
          if (url === '/main') {
            this.$router.replace(url)
          } else {
            location.href = `/main?url=${url}`
          }
        })
        .catch(error => {
          console.log(error)
          if (url === '/main') {
            this.$router.replace(url)
          } else {
            location.href = `/main?url=${url}`
          }
        })
    },
    setIsSaveId () {
      if (this.isIdSave) {
        // console.log('save id = '+ this.userId)
        this.$store.commit('saveId', this.userId)
      } else {
        this.$store.commit('deleteSaveId')
      }
    },
    onEnterKey (event) {
      this.onLogin(null)
    }
  }
}

</script>

<style lang="scss">
.html{
  background-color: white;
}
.login-page{
  position:relative;
  background-color: white;
  .container
  {
    width:650px;
    height:350px;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    border:1px solid rgb(226, 226, 226);
    background: url('../assets/image/bg.jpg') no-repeat 100%;
    #copy-right{
        font-weight: bold;
        color:#3d3d3d;
        text-align: center;
    }
    .login-content
    {
      margin: 60px 0 10px 300px;
      border:0px solid black;
      height:230px;
      width:340px;
      .login-table{
        width:100%;
        .login-button{
          margin: 0 5px;
        }
        td{
          text-align: left;
        }
        input{
          width:100%;
        }
        #place{
          td{
            padding-bottom: 15px;
            color:#414141;
            font-size: 1.2rem;
            font-weight: bold;
          }

        }
        #logo-image{
          height:60px;
          width:300px;
          background: url('../assets/image/login_title.png') no-repeat 0%;
        }
        #id-save{
          padding-top:10px;
        }
      }

    }
  }
  .dx-checkbox-icon{
    width:20px;
    height:20px;
  }
  .dx-checkbox-text{
    height:20px;
    width:200px;
    padding-top:1px;
    color: black;
  }
  .dx-texteditor{
    background-color: white!important;
    input {
      color:black;
    }
  }

}
</style>
